import { ComponentProps } from 'react';

interface Props extends ComponentProps<"svg"> {
  width: string;
  height: string;
}

const USAIcon = ({ width, height }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width={width} height={height}
    viewBox="0 0 512 512" style={{ background: 'new 0 0 512 512' }} xmlSpace="preserve">
    <circle style={{ fill: '#F0F0F0' }} cx="256" cy="256" r="256"/>
    <g>
      <path style={{fill: '#D80027' }} d="M244.87,256H512c0-23.106-3.08-45.49-8.819-66.783H244.87V256z"/>
      <path style={{fill: "#D80027"}} d="M244.87,122.435h229.556c-15.671-25.572-35.708-48.175-59.07-66.783H244.87V122.435z"/>
      <path style={{fill: "#D80027"}} d="M256,512c60.249,0,115.626-20.824,159.356-55.652H96.644C140.374,491.176,195.751,512,256,512z"/>
      <path style={{fill: "#D80027"}} d="M37.574,389.565h436.852c12.581-20.529,22.338-42.969,28.755-66.783H8.819
        C15.236,346.596,24.993,369.036,37.574,389.565z"/>
    </g>
    <path style={{fill: "#0052B4"}} d="M118.584,39.978h23.329l-21.7,15.765l8.289,25.509l-21.699-15.765L85.104,81.252l7.16-22.037
      C73.158,75.13,56.412,93.776,42.612,114.552h7.475l-13.813,10.035c-2.152,3.59-4.216,7.237-6.194,10.938l6.596,20.301l-12.306-8.941
      c-3.059,6.481-5.857,13.108-8.372,19.873l7.267,22.368h26.822l-21.7,15.765l8.289,25.509l-21.699-15.765l-12.998,9.444
      C0.678,234.537,0,245.189,0,256h256c0-141.384,0-158.052,0-256C205.428,0,158.285,14.67,118.584,39.978z M128.502,230.4
      l-21.699-15.765L85.104,230.4l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822l-21.7,15.765L128.502,230.4z
      M120.213,130.317l8.289,25.509l-21.699-15.765l-21.699,15.765l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822
      L120.213,130.317z M220.328,230.4l-21.699-15.765L176.93,230.4l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822
      l-21.7,15.765L220.328,230.4z M212.039,130.317l8.289,25.509l-21.699-15.765l-21.699,15.765l8.289-25.509l-21.7-15.765h26.822
      l8.288-25.509l8.288,25.509h26.822L212.039,130.317z M212.039,55.743l8.289,25.509l-21.699-15.765L176.93,81.252l8.289-25.509
      l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822L212.039,55.743z"/>
  </svg>
);

export default USAIcon;
